import { action } from "typesafe-actions";
import {
  ICompanyInformation,
  initialCompanyInformation,
} from "./companyInformation.types";
import { ThunkAction } from "redux-thunk";
import { AnyAction } from "redux";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { uploadFile } from "../../components/FileUpload/utils";

export const FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS =
  "FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS";
export const FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS =
  "FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS";
export const FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE =
  "FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE";

export const fetchAccountingCompanyInformationProgress = () =>
  action(FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS);
export const fetchAccountingCompanyInformationSuccess = (
  data: ICompanyInformation
) => action(FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS, { data });
export const fetchAccountingCompanyInformationFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE, { errorMessage });

export const fetchAccountingCompanyInformationAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingCompanyInformationProgress());

      const res = await api.get(`/siteConfiguration/get-site-configuration`);
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingCompanyInformationSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingCompanyInformationSuccess(
            initialCompanyInformation["data"]
          )
        );
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingCompanyInformationFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingCompanyInformationAysnc =
  (
    data: ICompanyInformation,
    logo: any | null,
    favIcon: any | null,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
        company_name: data.company_name,
      };
      const path1 = await uploadFile({
        file: logo,
        module_name: "SITE_CONFIGURATION",
        defaultReturn: data.logo || "",
        asPayload: { ...asPayload, filename: data.logo },
        onWarning: (message) => {
          dispatch(
            showMessage({
              type: "warning",
              message: message,
              displayAs: "snackbar",
            })
          );
        },
      });
      const path2 = await uploadFile({
        file: favIcon,
        module_name: "SITE_CONFIGURATION",
        defaultReturn: data.fav_icon || "",
        asPayload: { ...asPayload, filename: data.fav_icon },
        onWarning: (message) => {
          dispatch(
            showMessage({
              type: "warning",
              message: message,
              displayAs: "snackbar",
            })
          );
        },
      });
      await api.post("/siteConfiguration/upsert-site-configuration", {
        ...data,
        logo: path1,
        fav_icon: path2,
      });

      const message = "Company Information saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_ACCOUNTING_COMPANY_INFORMATION =
  "CLEAR_ACCOUNTING_COMPANY_INFORMATION";
export const clearAccountingCompanyInformation = () =>
  action(CLEAR_ACCOUNTING_COMPANY_INFORMATION);
